import { render, staticRenderFns } from "./AcademyParticipantFinish.vue?vue&type=template&id=77ea4bde&scoped=true"
import script from "./AcademyParticipantFinish.vue?vue&type=script&lang=ts"
export * from "./AcademyParticipantFinish.vue?vue&type=script&lang=ts"
import style0 from "./AcademyParticipantFinish.vue?vue&type=style&index=0&id=77ea4bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ea4bde",
  null
  
)

export default component.exports